import WorkLayout from "../../../layouts/WorkLayout/WorkLayout";
import WorkImage from "../../../components/WorkImage/WorkImage";
import WorkParagraph from "../../../components/WorkParagraph/WorkParagraph";
import AnimatedLink from "../../../components/AnimatedLink/AnimatedLink";

export default function _50SfumatureDiPinotNoir() {
  return (
    <>
      <WorkLayout
        title="50 Sfumature di Pinot Noir"
        desc="Logo Design for a wine tasting event."
      >
        <WorkImage
          cols="full"
          src="/assets/images/work/_50sfumaturedipinotnoir/10.jpg"
        />
        <WorkParagraph>
          50 Sfumature di Pinot Noir is a prominent wine tasting event hosted
          annually in Voghera (PV), Italy.
          <br />
          <br />
          For its fifth edition, in 2024, the organizers opted for a fresh,
          modern logo to represent the event. The design I created is a sleek,
          contemporary reinterpretation of the old logo, which featured a more
          traditional and colorful aesthetic. While the original symbolized the
          variety of Pinot Noir wines through vibrant colors, the new logo
          simplifies and refines this concept by maintaining the essence of the
          event in a more elegant and timeless form.
        </WorkParagraph>
        <WorkImage
          cols="6"
          src="/assets/images/work/_50sfumaturedipinotnoir/11.jpg"
        />
        <WorkImage
          cols="6"
          src="/assets/images/work/_50sfumaturedipinotnoir/02.jpg"
        />
        <WorkImage
          cols="6"
          src="/assets/images/work/_50sfumaturedipinotnoir/01.jpg"
        />
        <WorkImage
          cols="6"
          src="/assets/images/work/_50sfumaturedipinotnoir/20.jpg"
        />
        <WorkParagraph>
          The package was delivered with the necessary range of formats and variations and more, to ensure
          versatility across all branding needs. 
          <br /><br />
          The package included both
          full-color and black-and-white versions, along with negative
          variations for use on different backgrounds. To enhance flexibility,
          the logo was provided in horizontal and square layouts, suitable for
          various digital and print applications, including social media,
          promotional materials, and event signage. Each version was designed to
          maintain clarity and elegance, ensuring consistent visual identity
          across all platforms.
        </WorkParagraph>
        <WorkImage
          cols="full"
          src="/assets/images/work/_50sfumaturedipinotnoir/19.jpg"
          cn="aspect-auto h-auto"
        />
        <WorkImage
          cols="6"
          src="/assets/images/work/_50sfumaturedipinotnoir/08.jpg"
        />
        <WorkImage
          cols="6"
          src="/assets/images/work/_50sfumaturedipinotnoir/07.jpg"
        />
        <WorkImage
          cols="full"
          src="/assets/images/work/_50sfumaturedipinotnoir/01.jpg"
          cn="aspect-auto h-auto"
        />
      </WorkLayout>
    </>
  );
}
